export const formatFileSize = (size: number): string => {
  return size < 1024
    ? `${size} bytes`
    : size < 1024 * 1024
      ? `${(size / 1024).toFixed(2)} KB`
      : `${(size / 1024 / 1024).toFixed(2)} MB`;
};
